var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_40477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53804 1.90528C1.53804 0.874036 2.37466 0.0371094 3.40621 0.0371094C4.43746 0.0371094 5.27408 0.873735 5.27408 1.90528C5.27408 2.93743 4.43746 3.77406 3.40621 3.77406C2.37466 3.77376 1.53804 2.93743 1.53804 1.90528ZM10.0088 1.90528C10.0088 0.874036 10.8464 0.0371094 11.8776 0.0371094C12.9089 0.0371094 13.7458 0.873735 13.7458 1.90528C13.7458 2.93743 12.9092 3.77406 11.8776 3.77406C10.8467 3.77376 10.0088 2.93743 10.0088 1.90528ZM14.4257 9.55693C13.268 12.2343 10.5565 13.9642 7.51794 13.9642C4.41456 13.9642 1.68717 12.2256 0.569456 9.53463C0.377848 9.07369 0.596269 8.54466 1.05751 8.35306C1.17079 8.30636 1.28829 8.28406 1.40397 8.28406C1.75827 8.28406 2.09448 8.49375 2.23879 8.84171C3.07542 10.8557 5.14755 12.1569 7.51794 12.1569C9.8347 12.1569 11.8948 10.8548 12.7664 8.8393C12.9646 8.38107 13.4966 8.16988 13.9543 8.36872C14.4131 8.56665 14.624 9.0987 14.4257 9.55693Z",
    fill: "#181B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_40477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyIconLight);
export default __webpack_public_path__ + "static/media/HappyIconLight.4ae4d6dc32996f2d38151b456d9e903f.svg";
export { ForwardRef as ReactComponent };